.field {
  margin-bottom: var(--space-3);
}

.row {
  display: flex;
  align-items: center;
  min-height: var(--touch-min);
  cursor: pointer;
}

.box {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  margin: 0;
  margin-inline-end: var(--space-3);
  accent-color: var(--accent);
  cursor: pointer;
}

.box:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 2px;
}

.label {
  font-size: var(--text-md);
}

.hint {
  display: block;
  margin: -6px 0 0;
  margin-inline-start: 38px;
  font-size: var(--text-sm);
  color: var(--text-muted);
}
